const PAGE_SIZE_OPTIONS = [20, 50, 100];

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  loading?: boolean;
}

/** Compact mono prev/next pagination, designed to live inside <PageFooter right={...} />. */
export function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange, loading }: PaginationProps) {
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const canPrev = page > 1 && !loading;
  const canNext = page < lastPage && !loading;

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={() => onPageChange(1)}
        disabled={!canPrev}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        «
      </button>
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={!canPrev}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        ‹ prev
      </button>
      <span>
        page <b className="text-text-2">{page}</b> of <b className="text-text-2">{lastPage}</b>
      </span>
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={!canNext}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        next ›
      </button>
      <button
        type="button"
        onClick={() => onPageChange(lastPage)}
        disabled={!canNext}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        »
      </button>
      {onPageSizeChange && (
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="bg-panel border border-border rounded px-1.5 py-0.5 text-text-2 text-xs font-mono cursor-pointer outline-none focus:border-accent"
        >
          {PAGE_SIZE_OPTIONS.map((s) => (
            <option key={s} value={s}>{s} / page</option>
          ))}
        </select>
      )}
    </div>
  );
}
